/**
 * Short bio blurbs for the three voices in the daily reflection rotation.
 * Detected from the reflection body: if a body contains "— John Wesley" or
 * "— B.T. Roberts" we surface that author's bio; otherwise (the classic
 * unsigned Practice-of-the-Presence quotes) we default to Brother Lawrence.
 */

export const AUTHORS = {
  wesley: {
    key: 'wesley',
    name: 'John Wesley',
    dates: '1703 – 1791',
    role: 'Founder of the Methodist movement',
    bio: (
      "John Wesley was an Anglican priest whose open-air preaching in 18th-century " +
      "England helped spark a nationwide revival known as the Great Awakening. His " +
      "insistence on personal holiness, small-group accountability (the original " +
      "\"class meetings\"), and social justice — abolition of slavery, ministry to " +
      "prisoners, care for the poor — reshaped English-speaking Christianity. His " +
      "core message: God's grace transforms us, and the Christian life is a journey " +
      "into perfect love for God and neighbor."
    ),
  },
  roberts: {
    key: 'roberts',
    name: 'B.T. Roberts',
    dates: '1823 – 1893',
    role: 'Founder of the Free Methodist Church',
    bio: (
      "Benjamin Titus Roberts was an American Methodist minister who founded the " +
      "Free Methodist Church in 1860. \"Free\" meant three things: the gospel " +
      "preached free to the poor (no pew rents), Christians freed from the entanglements " +
      "of the world (holiness of life), and slaves freed from bondage. He founded Roberts " +
      "Wesleyan College, argued for women's ordination decades before it was popular, " +
      "and gave his life to the conviction that the Church's calling is holiness lived " +
      "out in the service of the least."
    ),
  },
  brotherLawrence: {
    key: 'brotherLawrence',
    name: 'Brother Lawrence',
    dates: 'c. 1614 – 1691',
    role: 'Carmelite lay brother',
    bio: (
      "Born Nicholas Herman in French Lorraine, he served as a soldier and footman " +
      "before joining a Carmelite monastery in Paris as a lay brother. He spent " +
      "most of his life in the monastery kitchen, and it was there — over pots and " +
      "pans — that he learned what he called \"the practice of the presence of God.\" " +
      "After his death, letters and conversations were collected into a small book " +
      "of the same name that has become one of the most beloved works of Christian " +
      "spirituality. His message: God is available to be loved in every ordinary " +
      "moment, and the work of your hands can be worship."
    ),
  },
};

/**
 * Try to detect which author authored a given reflection body.
 * Returns the matching AUTHORS entry, or null if none matched.
 */
export const detectAuthor = (body) => {
  if (!body) return null;
  const lower = body.toLowerCase();
  if (lower.includes('john wesley')) return AUTHORS.wesley;
  if (lower.includes('b.t. roberts')) return AUTHORS.roberts;
  // Unsigned entries in our rotation are always Brother Lawrence.
  return AUTHORS.brotherLawrence;
};
